<nav class="top-nav">
	<ng-container *ngIf="shouldShowLeftArrow(currentPathIndex); else emptyStub">
		<a
			class="col-9 text-10"
			[routerLink]="[getPreviousRoute(currentPathIndex)]"
			[queryParams]="queryParams"
			[attr.data-link-event]="'leftnav:' + (getPreviousLabel(currentPathIndex) | slugify)"
		>
			<span class="segment">
				<icon type="chevron-left" class="icon icon-left"></icon> <span class="icon-caption-left">{{ getPreviousLabel(currentPathIndex) }}</span>
			</span>
		</a>
	</ng-container>
	<a class="col-7 text-align-center text-14" dcrHTMLKey="GO_TO_SECTION" (click)="toggleMenu()">Go to Section</a>
	<ng-container *ngIf="shouldShowRightArrow(currentPathIndex); else emptyStub">
		<a
			class="col-9 text-10"
			[routerLink]="[getNextRoute(currentPathIndex)]"
			[queryParams]="queryParams"
			[attr.data-link-event]="'leftnav:' + (getNextLabel(currentPathIndex) | slugify)"
		>
			<span class="segment">
				<span class="icon-caption-right">{{ getNextLabel(currentPathIndex) }}</span> <icon type="chevron-right" class="icon icon-right"></icon>
			</span>
		</a>
	</ng-container>
	<ng-template #emptyStub><a class="col-9"></a></ng-template>
</nav>

<nav tabindex="0" class="side-nav" [ngClass]="{ expanded: expanded, 'expand-on-focus': expandOnFocus }">
	<icon type="times" class="pull-right icon-close hidden d-inline-block-sm" (click)="toggleMenu()"></icon>
	<ul class="name-plate hidden d-block-sm text-13-demi" *ngIf="data?.success && data?.portfolioData">
		<li *ngFor="let portfolioData of data.portfolioData">{{ portfolioData.field?.name?.formattedValue }}</li>
	</ul>
	<ul
		class="path-wrapper text-16 d-block-sm"
		[ngClass]="{
			'text-md-12': routePathsToShow.length >= 9,
			'text-md-14': routePathsToShow.length < 9,
			'add-gutter': enableGutter
		}"
	>
		<ng-container *ngFor="let path of routePathsToShow">
			<ng-container *showOnlyInView="path.showOnlyInView">
				<li class="path">
					<a
						[routerLinkActive]="'active'"
						[routerLink]="[path.route]"
						[queryParams]="queryParams"
						[attr.data-link-event]="'leftnav:' + ('' | dcr: (path.id + '_TAB_NAME' | slugify: '_' | uppercase) | slugify)"
						tabindex=""
						(click)="toggleMenu()"
					>
						<span class="path-text" [dcrHTMLKey]="path.id + '_TAB_NAME' | slugify: '_' | uppercase">
							<span>{{ path.id + '_TAB_NAME' | slugify: '_' | uppercase }}</span>
						</span>
						<div *ngIf="path.showNewFlag" class="new-flag text-12-bold text-align-center" dcrHTMLKey="NEW_TAB_LABEL_DCR">NEW</div>
					</a>
				</li>
			</ng-container>
		</ng-container>
	</ul>
</nav>
<!-- To be used later once it's completely ready -->
<!-- <dz-sidenav [navItems]="navItems" [expandOnFocus]="expandOnFocus" [queryParams]="queryParams" position="left" [enableGutter]="enableGutter"></dz-sidenav> -->
